import classNames from 'classnames'
import {memo} from 'react'

import {TestStatus} from '../../../../Tests.types'
import {DataTypes} from '../../../TestHistoryChart.types'
import {BAR_MARGIN, CHART_HEIGHT, CHART_PADDING} from '../../../TestHistoryChart.utils'

import type {Props} from './Bar.types'
import BarAveragePopup from './BarPopup/BarAveragePopup'
import BarPopup from './BarPopup/BarPopup'

import styles from './Bar.css'

const FAILED_LINE_WIDTH = 2
const COLUMN_HEADER_HEIGHT = 2

function Bar({x = 0, y = 0, datum, barWidth}: Props) {
  if (datum == null) {
    return null
  }

  const renderBar = (
    <div className={styles.column}>
      <div
        className={styles.header}
        style={{
          backgroundColor: datum.color,
        }}
      />
      <div className={styles.body} />
    </div>
  )
  const barWidthWithoutMargin = parseFloat((barWidth - BAR_MARGIN).toFixed(2))
  return (
    <svg
      className={classNames({
        [styles.failed]: datum.type === DataTypes.DEFAULT && datum.status === TestStatus.FAILURE,
      })}
    >
      <foreignObject
        x={parseFloat((x + barWidthWithoutMargin / 2 - FAILED_LINE_WIDTH / 2).toFixed(2))}
        y={0}
        width={FAILED_LINE_WIDTH}
        height={y - COLUMN_HEADER_HEIGHT}
      >
        <div className={styles.failedLine} />
      </foreignObject>
      <foreignObject
        x={parseFloat(x.toFixed(2))}
        y={y - COLUMN_HEADER_HEIGHT}
        width={barWidthWithoutMargin}
        height={CHART_HEIGHT - y + CHART_PADDING.top + COLUMN_HEADER_HEIGHT}
      >
        {datum.type === DataTypes.DEFAULT ? (
          <BarPopup
            anchor={renderBar}
            buildId={datum.buildId}
            duration={datum.y}
            testOccurrenceId={datum.testOccurrenceId}
          />
        ) : (
          <BarAveragePopup
            anchor={renderBar}
            duration={datum.y}
            buildsCount={datum.countBuilds}
            date={datum.date}
          />
        )}
      </foreignObject>
    </svg>
  )
}

export default memo<Props>(Bar)
